import * as apiGetTodos from "@/api/vp/personalTodos/getTodos.js";

import * as apiCreateCategory from "@/api/vp/personalTodos/createCategory.js";
import * as apiDeleteCategory from "@/api/vp/personalTodos/deleteCategory.js";

import * as apiDeleteTodo from "@/api/vp/personalTodos/deleteTodo.js";
import * as apiCreateTodo from "@/api/vp/personalTodos/createTodo.js";

import * as apiUpdateTodo from "@/api/vp/personalTodos/updateTodo.js";
import * as apiUpdateTodoCompleted from "@/api/vp/personalTodos/updateTodoCompleted.js";
import * as apiUpdateTodoOrder from "@/api/vp/personalTodos/updateTodoOrder.js";

import * as apiGetActiveUserRoles from "@/api/vp/personalTodos/getActiveUserRoles.js";


import _ from "lodash";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    filterTypes: [{
      name: "Flagged",
      filter: "flagged",
      color: "blue",
      icon: "FlagIcon"
    }, {
      name: "Today",
      filter: "today",
      color: "red",
      icon: "HomeIcon"
    }, {
      name: "Scheduled",
      filter: "scheduled",
      color: "yellow",
      icon: "CalendarIcon"
    }, {
      name: "All",
      filter: "all",
      color: "primary",
      icon: "InboxIcon"
    },],
    venueId: null,
    role: null,
    loading: false,
    category: null,
    showCompleted: true,
    selectedCategoryIdx: 0,
    categories: [],
    filter: "",
    roles: [],
    searchQuery: "",
    allowedRoles: ["sm", "vm", "avm", "svm", "vm-test", "sm-test"]
  },
  mutations: {
    gotTodos(state, result) {
      state.categories = result.categories;
    },

    gotUserRoles(state, result) {
      state.roles = result.filter(e => state.allowedRoles.includes(e.roleId));
      if (state.roles.length > 0) state.role = state.roles[0];
    },

    isLoading(state, loading) {
      state.loading = loading;
    },

    setFilter(state, filter) {
      state.filter = filter;
    },

    setCategory(state, idx) {
      state.searchQuery = ""
      state.selectedCategoryIdx = idx;
    },

    setMandatoryFields(state, { venueId, role }) {
      state.venueId = venueId;
      state.role = role;
    },

    toggleShowCompleted(state) {
      state.showCompleted = !state.showCompleted;
    },

    setRole(state, roleIdx) {
      state.role = state.roles[roleIdx]
    },
    setSearchQuery(state, value) {
      state.searchQuery = value.toLowerCase();
    }
  },
  actions: {
    async setRole({ commit, dispatch }, roleIdx) {
      commit("setRole", roleIdx);
      await dispatch("getTodos");
    },
    async toggleShowCompleted({ commit }) {
      commit("toggleShowCompleted");
    },
    async initializeTodos({ commit }, { venueId }) {
      commit("setMandatoryFields", { venueId });
    },
    async changeFilter({ commit }, filter) {
      commit("setFilter", filter);
    },
    async changeCategory({ commit }, idx) {
      commit("setCategory", idx);
    },
    async getUserRoles({ commit, state }, venueId) {
      commit("isLoading", true);

      const result = await apiGetActiveUserRoles.get(venueId);

      if (result) {
        commit("gotUserRoles", result);
      }

      commit("isLoading", false);
    },
    async getTodos({ commit, state }) {
      commit("isLoading", true);

      console.log("Getting todos for", state.role.title, state.role.roleId);

      const result = await apiGetTodos.get(state.venueId, state.role.roleId);

      if (result) {
        commit("gotTodos", result);
      }

      commit("isLoading", false);
    },

    async createCategory({ commit, dispatch, state, getters }, { name, icon, color }) {
      const payload = {
        venueId: state.venueId,
        role: state.role.roleId,
        name: name,
        icon: icon,
        color: color
      }
      const result = await apiCreateCategory.post(payload);
      await dispatch("getTodos");
      return result;
    },

    async createTodo({ commit, dispatch, state, getters }, todo) {
      const payload = {
        ...todo,
        venueId: state.venueId,
        categoryId: getters.category.id,
        role: state.role.roleId,
      }
      const result = await apiCreateTodo.post(payload);
      await dispatch("getTodos");
      return result;
    },

    async updateTodo({ commit, dispatch, state, getters }, { todoId, categoryId, todo }) {
      const payload = {
        ...todo,
        id: todoId,
        venueId: state.venueId,
        categoryId: categoryId,
        role: state.role.roleId,
      }
      const result = await apiUpdateTodo.put(payload);
      await dispatch("getTodos");
      return result;
    },

    async updateTodoOrder({ commit, dispatch, state, getters }, { oldIndex, newIndex }) {
      const todoId = getters.category.todos[newIndex].id
      const payload = {
        id: todoId,
        role: state.role.roleId,
        venueId: state.venueId,
        categoryId: getters.category.id,
        oldIndex: oldIndex,
        newIndex: newIndex
      }
      const result = await apiUpdateTodoOrder.put(payload);
      await dispatch("getTodos");
      return result;

    },


    async deleteCategory({ commit, dispatch, state, getters }) {
      const result = await apiDeleteCategory.del(state.venueId, state.role.roleId, getters.category.id);
      await dispatch("getTodos");
      return result;
    },

    async deleteTodo({ commit, dispatch, state, getters }, { todoId, categoryId }) {
      const result = await apiDeleteTodo.del(state.venueId, state.role.roleId, categoryId, todoId);
      await dispatch("getTodos");
      return result;
    },


    async updateTodoCompleted({ commit, dispatch, state, getters }, { todoId, categoryId, completed }) {
      const payload = {
        id: todoId,
        venueId: state.venueId,
        role: state.role.roleId,
        categoryId: categoryId,
        completed: completed !== 0
      }
      const result = await apiUpdateTodoCompleted.put(payload);
      await dispatch("getTodos");
      return result;
    },



    /*async orderChanged({ commit, dispatch }, { todos }) {
      const payload = {
        venueId: venueId,
        role: role,
        categories: categories
      };
      const result = await apiSetCategories.post(payload);

      await dispatch("getTodos", { venueId: venueId, role: role });

      return result;
    },*/

  },
  getters: {
    searchQuery: state => state.searchQuery,
    allowedRoles: state => state.allowedRoles,
    role: state => state.role,
    roles: state => state.roles,
    filterTypes: state => state.filterTypes,
    showCompleted: state => state.showCompleted,
    categoryIdx: state => state.selectedCategoryIdx,
    category: state => state.categories[state.selectedCategoryIdx],
    categories: state => {
      return state.categories;
    },
    filter: state => state.filter,
    filterName: state => state.filter.charAt(0).toUpperCase() + state.filter.slice(1),
    isFiltering: state => state.filter !== "",
    allTodos: state => {
      const allTodos = state.categories.map((e) => e.todos.map(t => { return { ...t, categoryIcon: e.icon, categoryName: e.name, categoryColor: e.color } }));
      return allTodos.flat(1);
    },
    todosByFilter: (state, getters) => getters.todosByFilterType(state.filter),
    todosByFilterType: (state, getters) => (type) => {
      return getters.allTodos.filter((e) => {
        if (!state.showCompleted && e.completed) return false;
        switch (type) {
          case 'flagged':
            return e.flagged;
          case 'today':
            return e.hasDueDate && moment(e.startDate).isSame(new Date(), "day");
          case 'scheduled':
            return e.hasDueDate === true;
          case 'search':
            return e.title.toLowerCase().startsWith(state.searchQuery) || e.note.startsWith(state.searchQuery)
          default:
            return true;
        }
      });
    },
    todos: (state, getters) => {
      return state.filter === ""
        ? getters.category.todos
        : getters.todosByFilter;
    }
  }
};
